// extracted by css-extract-rspack-plugin
export default {"checkboxGrid":"ContentfulCheckboxGroupInput-module__checkboxGrid__PNJWLPA"};